import dashboardModule from "../vxPanelGrid.module";

// Right-click directive
dashboardModule.directive('ngRightClick', ['$parse', function($parse) {
    return function(scope, element, attrs) {
        var fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function(event) {
            event.preventDefault();
            scope.$apply(function() {
                fn(scope, {$event: event});
            });
        });
    };
}]);

dashboardModule.directive('tablePanel', ['msgBus', 'msgBusActions', function(msgBus, msgBusActions) {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            panelConfig: '='
        },
        template: `
      <style>
        .modern-table-wrapper {
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          position: relative;
          max-height: 600px;
          overflow-y: auto;
          will-change: scroll-position;
        }
        .modern-table {
          width: 100%;
          border-collapse: collapse;
          background-color: #fff;
        }
        .modern-table thead {
          background-color: #153F60; /* vx-blue-bg from styleguide */
          color: #ffffff;
          font-weight: 500;
          border-bottom: 1px solid #0f2e46;
        }
         .modern-table thead {
           position: sticky;
           top: 0;
           z-index: 10;
           display: table-header-group;
         }
         .modern-table thead tr {
           display: table-row;
         }
         .modern-table thead th {
           position: relative;
           border: none;
           font-size: 11px;
           text-transform: none;
           letter-spacing: 0.2px;
           padding: 0;
         }
         .table-header-content {
           display: flex;
           align-items: center;
           gap: 8px;
           padding: 6px 8px;
           justify-content: flex-start;
         }
          .modern-table thead th.numeric .table-header-content,
          .modern-table thead th.currency .table-header-content {
            justify-content: flex-end;
          }
          .modern-table thead th.currency {
            min-width: 140px;
          }
         .table-header-label {
           white-space: nowrap;
           flex: 0 1 auto;
         }
          .table-header-actions {
            display: flex;
            gap: 4px;
            visibility: hidden;
            flex-shrink: 0;
          }
          .modern-table thead th.numeric .table-header-actions,
          .modern-table thead th.currency .table-header-actions {
            order: -1;
          }
         .modern-table thead th:hover .table-header-actions,
         .modern-table thead th .table-header-actions.has-active {
           visibility: visible;
         }
        .sort-btn, .group-btn {
          background: transparent;
          border: none;
          cursor: pointer;
          font-size: 11px;
          padding: 2px 4px;
          opacity: 0.7;
          transition: opacity 0.15s, background 0.15s;
          white-space: nowrap;
          border-radius: 3px;
          color: #e2e8f0;
        }
        .sort-btn:hover, .group-btn:hover {
          opacity: 1;
          background: rgba(255, 255, 255, 0.1);
        }
        .sort-btn.active, .group-btn.active {
          opacity: 1;
          color: #EF7123; /* vx-orange accent */
          background: rgba(239, 113, 35, 0.18);
        }
        .modern-table tbody tr {
          border-bottom: 1px solid #e2e6f0;
          transition: background-color 0.15s ease;
        }
        .modern-table tbody tr:nth-child(odd):not(.group-header) {
          background-color: #fbfcff;
        }
        .modern-table tbody tr:nth-child(even):not(.group-header) {
          background-color: #f4f6fb;
        }
        .modern-table tbody tr:hover:not(.group-header) {
          background-color: #e9efff;
        }
        .modern-table tbody tr.clickable-row {
          cursor: pointer;
        }
        .modern-table tbody td {
          padding: 8px 10px;
          font-size: 12px;
          color: #2d3748;
        }
        .group-header {
          background: linear-gradient(90deg, #edf0ff 0%, #f7f8ff 100%);
          border-left: 3px solid #4c6fff;
          font-weight: 600;
          color: #4c6fff;
          text-transform: uppercase;
          letter-spacing: 0.4px;
          font-size: 11px;
          padding: 6px 10px !important;
          cursor: default;
        }
        .group-header:hover {
          background: linear-gradient(90deg, #f5f7ff 0%, #f9faff 100%) !important;
        }
        .modern-table tbody tr:last-child {
          border-bottom: none;
        }
        .table-loading {
          height: 400px;
          text-align: center;
          vertical-align: middle;
          width: 100%;
        }
        .table-loader {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          color: #667;
          font-size: 13px;
          padding-top: 150px;
        }
        .table-spinner {
          width: 32px;
          height: 32px;
          border: 3px solid #e2e6f0;
          border-top-color: #4c6fff;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }
         @keyframes spin {
           to { transform: rotate(360deg); }
         }
         .export-btn-small {
           background-color: #153F60;
           color: #ffffff;
           border: none;
           padding: 4px 10px;
           border-radius: 3px;
           cursor: pointer;
           font-size: 12px;
           font-weight: 500;
           transition: background-color 0.2s, opacity 0.2s;
           white-space: nowrap;
         }
         .export-btn-small:hover {
           background-color: #0f2e46;
           opacity: 0.9;
         }
          .export-btn-small:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
          .modern-table tbody td.numeric,
          .modern-table tbody td.currency {
            text-align: right;
            font-family: 'Courier New', monospace;
            font-variant-numeric: tabular-nums;
          }
        </style>
       <div class="modern-table-wrapper">
       <table class="modern-table">
        <thead>
           <tr>
              <th ng-repeat="header in visibleHeaders" 
                  style="cursor: default; user-select: none; padding: 0;"
                  ng-class="{active: sortColumn === header.key, grouped: groupColumn === header.key, 'numeric': header.type === 'numeric', 'currency': header.type === 'currency'}">
               <div class="table-header-content">
                 <span class="table-header-label">{{header.label}}</span>
                 <span class="table-header-actions" ng-class="{'has-active': sortColumn === header.key || groupColumn === header.key}" ng-if="header.sortable !== false || header.groupable !== false">
                   <button class="sort-btn" 
                           ng-if="header.sortable !== false"
                           ng-click="sortBy(header.key)"
                           ng-class="{active: sortColumn === header.key}"
                           title="Sort by this column">
                     <span ng-show="sortColumn === header.key">{{sortAsc ? '▲' : '▼'}}</span>
                     <span ng-hide="sortColumn === header.key">↕</span>
                   </button>
                   <button class="group-btn" 
                           ng-if="header.groupable !== false"
                           ng-click="groupBy(header.key)"
                           ng-class="{active: groupColumn === header.key}"
                           title="Group by this column">
                     <span ng-show="groupColumn === header.key">🔗</span>
                     <span ng-hide="groupColumn === header.key">⊞</span>
                   </button>
                 </span>
               </div>
             </th>
          </tr>
        </thead>
        <tbody ng-if="isLoading">
          <tr>
            <td colspan="{{data.headers.length}}" class="table-loading">
              <div class="table-loader">
                <div class="table-spinner"></div>
                <span>Loading...</span>
              </div>
            </td>
          </tr>
        </tbody>
         <tbody ng-if="!isLoading && groupColumn">
           <tr ng-repeat-start="group in displayGroups track by group.key" class="group-header">
             <td colspan="{{visibleHeaders.length}}">{{group.key}}</td>
           </tr>
            <tr ng-repeat="row in group.rows track by $index" ng-class="{'clickable-row': isClickable}" ng-click="onRowClick(row)">
              <td ng-repeat="header in visibleHeaders track by header.key" ng-class="{'numeric': header.type === 'numeric', 'currency': header.type === 'currency'}">{{getCellDisplayValue(row[header.key])}}</td>
            </tr>
           <tr ng-repeat-end style="display:none;"></tr>
         </tbody>
         <tbody ng-if="!isLoading && !groupColumn">
            <tr ng-repeat="row in displayRows track by $index" ng-class="{'clickable-row': isClickable}" ng-click="onRowClick(row)">
              <td ng-repeat="header in visibleHeaders track by header.key" ng-class="{'numeric': header.type === 'numeric', 'currency': header.type === 'currency'}">{{getCellDisplayValue(row[header.key])}}</td>
            </tr>
         </tbody>
      </table>
      </div>
    `,
        link: function(scope, element) {
             scope.sortColumn = null;
             scope.sortAsc = true;
             scope.displayRows = [];
             scope.displayGroups = [];
             scope.groupColumn = null;
             scope.isLoading = false;
             scope.showLoader = false;
             scope.visibleHeaders = [];
             scope.isClickable = false;
             var pendingGroupOperation = null;
             var loaderTimeout = null;
             
             // Expose table controls to parent panel config
             if (scope.panelConfig) {
                 scope.panelConfig.tableControls = {
                     showExportButton: true,
                     exportFunction: function() { scope.exportToExcel(); }
                 };
             }
            
             // Helper function to extract display value from dual-value structure or plain value
             scope.getCellDisplayValue = function(cellValue) {
                 if (cellValue == null) return '';
                 if (typeof cellValue === 'object' && cellValue.displayValue !== undefined) {
                     return cellValue.displayValue;
                 }
                 return cellValue;
             };

             // Helper function to extract real value for sorting/comparison
             var getCellRealValue = function(cellValue) {
                 if (cellValue == null) return null;
                 if (typeof cellValue === 'object' && cellValue.value !== undefined) {
                     return cellValue.value;
                 }
                 return cellValue;
             };

             // Filter visible headers (exclude hidden columns)
             var updateVisibleHeaders = function() {
                 if (scope.data && scope.data.headers) {
                     scope.visibleHeaders = scope.data.headers.filter(function(h) {
                         return h.hidden !== true;
                     });
                     // Check if rows are clickable (have id and itemType)
                     scope.isClickable = scope.data.headers.some(function(h) {
                         return h.key === 'id' || h.field === 'id';
                     }) && scope.data.headers.some(function(h) {
                         return h.key === 'itemType' || h.field === 'itemType';
                     });
                 } else {
                     scope.visibleHeaders = [];
                     scope.isClickable = false;
                 }
             };
            
             // Handle row click - open tab by type
             scope.onRowClick = function(row) {
                 if (!scope.isClickable || !row) return;
                 var id = row.id;
                 var type = row.itemType;
                 if (id && type) {
                     msgBus.emitMsg(msgBusActions.shellOpenTabByType, {
                         type: type,
                         id: id
                     });
                 }
             };
             
              // Export table data to Excel
              scope.exportToExcel = function() {
                  if (!scope.data || !scope.data.rows || scope.data.rows.length === 0) {
                      console.warn('No data to export');
                      return;
                  }
                  
                  try {
                      // Get visible headers
                      var headers = scope.visibleHeaders;
                      var rows = scope.data.rows;
                      
                      // Build data array for export
                      var exportData = [];
                      
                      // Add header row
                      var headerRow = [];
                      headers.forEach(function(header) {
                          headerRow.push(header.label || header.key);
                      });
                      exportData.push(headerRow);
                      
                      // Add data rows - use real values when available, otherwise display values
                      rows.forEach(function(row) {
                          var dataRow = [];
                          headers.forEach(function(header) {
                              var cellValue = row[header.key];
                              var exportValue;
                              
                              // If it's a dual-value structure, prefer the real value
                              if (typeof cellValue === 'object' && cellValue.value !== undefined) {
                                  exportValue = cellValue.value;
                              } else {
                                  // Fallback to display value
                                  exportValue = scope.getCellDisplayValue(cellValue);
                              }
                              
                              dataRow.push(exportValue || '');
                          });
                          exportData.push(dataRow);
                      });
                      
                      // Calculate column widths based on content
                      var colWidths = [];
                      for (var i = 0; i < headers.length; i++) {
                          var maxWidth = headers[i].label.length;
                          for (var j = 1; j < exportData.length; j++) {
                              var cellValue = String(exportData[j][i] || '');
                              if (cellValue.length > maxWidth) {
                                  maxWidth = cellValue.length;
                              }
                          }
                          // Convert character width to Excel column width
                          colWidths.push({wch: Math.min(maxWidth + 2, 50)});
                      }
                      
                      // Generate filename with timestamp
                      var timestamp = new Date().toISOString().slice(0, 10);
                      var filename = 'table-export-' + timestamp;
                      
                       // Call export function (uses global export_objects_to_excel from Export2Excel.js)
                       if (window.export_objects_to_excel) {
                           window.export_objects_to_excel(filename, exportData, colWidths);
                       } else {
                           console.error('Export function not available');
                       }
                   } catch (error) {
                       console.error('Export failed:', error);
                   }
               };
            
            // Ensure headers have keys - if missing, derive from field or first row
            var ensureHeaderKeys = function() {
                if (scope.data && scope.data.headers) {
                    var firstRow = scope.data.rows && scope.data.rows.length > 0 ? scope.data.rows[0] : null;
                    var propertyKeys = firstRow ? Object.keys(firstRow) : [];
                    
                    scope.data.headers.forEach(function(header, index) {
                        // Map 'field' to 'key' if key is missing
                        if (!header.key && header.field) {
                            header.key = header.field;
                        }
                        // Fallback to first row property keys if still no key
                        if (!header.key && propertyKeys[index]) {
                            header.key = propertyKeys[index];
                        }
                    });
                    // Update visible headers after ensuring keys
                    updateVisibleHeaders();
                }
            };

            scope.groupBy = function(propertyKey) {
                // Cancel any pending grouping operation
                if (pendingGroupOperation) {
                    clearTimeout(pendingGroupOperation);
                    pendingGroupOperation = null;
                }

                // Toggle grouping if clicking the same column, otherwise switch to new grouping
                console.log('groupBy called with:', propertyKey, 'current groupColumn:', scope.groupColumn);
                if (scope.groupColumn === propertyKey) {
                    // Ungroup: clicking the same grouped column
                    console.log('UNGROUPING');
                    scope.groupColumn = null;
                    scope.displayGroups = [];
                    
                    // Restore display rows - just reference original data, no sort reapply
                    scope.displayRows = scope.data && scope.data.rows ? scope.data.rows : [];
                    scope.sortColumn = null; // Clear sort when ungrouping to avoid expensive re-sort
                    
                    console.log('After ungroup - groupColumn:', scope.groupColumn, 'displayRows length:', scope.displayRows.length, 'displayGroups length:', scope.displayGroups.length);
                    
                    // Scroll to top after ungrouping
                    var scroller = element.find('.modern-table-wrapper')[0];
                    if (scroller) scroller.scrollTop = 0;
                } else {
                    // Switch to new grouping (cancel previous if any)
                    var targetKey = propertyKey;
                    scope.groupColumn = targetKey;
                    scope.isLoading = true;
                    scope.showLoader = false;
                    
                    // Clear loader timeout if exists
                    if (loaderTimeout) {
                        clearTimeout(loaderTimeout);
                    }
                    
                    // Show loader after 100ms if still loading
                    loaderTimeout = setTimeout(function() {
                        if (scope.isLoading) {
                            scope.$apply(function() {
                                scope.showLoader = true;
                            });
                        }
                    }, 100);
                    
                    // Scroll to top before grouping
                    var scroller = element.find('.modern-table-wrapper')[0];
                    if (scroller) scroller.scrollTop = 0;
                    
                    // Build new groups on next digest to minimize DOM thrash
                    pendingGroupOperation = setTimeout(function() {
                        scope.$apply(function() {
                            // Only perform grouping if this column is still the active one
                            if (scope.groupColumn === targetKey) {
                                performGrouping(targetKey);
                                scope.isLoading = false;
                                scope.showLoader = false;
                                if (loaderTimeout) {
                                    clearTimeout(loaderTimeout);
                                    loaderTimeout = null;
                                }
                            }
                        });
                        pendingGroupOperation = null;
                    }, 10);
                }
            };

             var performGrouping = function(propertyKey) {
                 if (!scope.data || !scope.data.rows) return;
                 
                 var grouped = {};
                 var groupOrder = [];
                 var groupKeyMap = {}; // Map lowercase key to original key
                 var i, row, rawGroupKey, groupKey, displayGroupKey;
                 
                 // Group rows by property value - optimized loop with case-insensitive grouping
                 for (i = 0; i < scope.data.rows.length; i++) {
                     row = scope.data.rows[i];
                     rawGroupKey = row[propertyKey];
                     
                     // Extract display value from dual-value structure
                     displayGroupKey = scope.getCellDisplayValue(rawGroupKey);
                     
                     // Convert to lowercase for grouping (case-insensitive)
                     groupKey = displayGroupKey != null ? String(displayGroupKey).toLowerCase() : '';
                     
                     if (!grouped[groupKey]) {
                         grouped[groupKey] = [];
                         groupOrder.push(groupKey);
                         // Store the original display value for display
                         groupKeyMap[groupKey] = displayGroupKey;
                     }
                     grouped[groupKey].push(row);
                 }
                 
                 // Sort groups alphabetically (case-insensitive)
                 groupOrder.sort();
                 
                 // Build display groups - no map operation for better performance
                 var displayGroups = new Array(groupOrder.length);
                 for (i = 0; i < groupOrder.length; i++) {
                     displayGroups[i] = {
                         key: groupKeyMap[groupOrder[i]], // Use display value for display
                         rows: grouped[groupOrder[i]]
                     };
                 }
                 scope.displayGroups = displayGroups;
             };

             scope.sortBy = function(propertyKey) {
                 // If clicking the same column, toggle sort direction
                 if (scope.sortColumn === propertyKey) {
                     scope.sortAsc = !scope.sortAsc;
                 } else {
                     // New column, default to ascending
                     scope.sortColumn = propertyKey;
                     scope.sortAsc = true;
                 }

                 var sortFn = function(a, b) {
                     var aVal = a[propertyKey];
                     var bVal = b[propertyKey];

                     // Extract real values (for dual-value structure, use 'value' field)
                     var aRealVal = getCellRealValue(aVal);
                     var bRealVal = getCellRealValue(bVal);

                     // Handle null/undefined
                     if (aRealVal == null && bRealVal == null) return 0;
                     if (aRealVal == null) return scope.sortAsc ? 1 : -1;
                     if (bRealVal == null) return scope.sortAsc ? -1 : 1;

                     // Numeric comparison if both real values are numbers
                     if (typeof aRealVal === 'number' && typeof bRealVal === 'number') {
                         return scope.sortAsc ? aRealVal - bRealVal : bRealVal - aRealVal;
                     }

                     // String comparison (fallback for non-numeric values)
                     var aStr = String(aRealVal).toLowerCase();
                     var bStr = String(bRealVal).toLowerCase();
                     if (scope.sortAsc) {
                         return aStr < bStr ? -1 : aStr > bStr ? 1 : 0;
                     } else {
                         return aStr > bStr ? -1 : aStr < bStr ? 1 : 0;
                     }
                 };

                 // If grouping is active, sort within each group
                 if (scope.groupColumn && scope.displayGroups.length > 0) {
                     for (var i = 0; i < scope.displayGroups.length; i++) {
                         scope.displayGroups[i].rows.sort(sortFn);
                     }
                     return;
                 }

                 // Perform the sort on flat list
                 if (scope.data && scope.data.rows) {
                     scope.displayRows = scope.data.rows.slice(0);
                     scope.displayRows.sort(sortFn);
                 }
             };

            // Watch for data changes - use shallow watch for performance
            var dataInitialized = false;
            scope.$watch('data.rows', function(newVal, oldVal) {
                if (newVal && newVal.length > 0) {
                    // Only process if data actually changed or first load
                    if (newVal === oldVal && dataInitialized) {
                        return;
                    }
                    dataInitialized = true;
                    
                    // derive header keys if missing
                    ensureHeaderKeys();
                    
                    if (scope.groupColumn !== null) {
                        // Reapply grouping
                        performGrouping(scope.groupColumn);
                    } else if (scope.sortColumn !== null) {
                        // Reapply current sort
                        scope.sortBy(scope.sortColumn);
                    } else {
                        // Initialize display rows without copy (reference is fine)
                        scope.displayRows = newVal;
                    }
                } else {
                    scope.displayRows = [];
                    scope.displayGroups = [];
                }
            }, false); // Changed to false for shallow watch
        }
    };
}]);
